import React from 'react';
import { Link } from 'react-router-dom';

const ProductCapabilities = () => {
    const cards = [
        {
            id: '01',
            title: 'Trading',
            color: 'bg-[#F1F1F1]',
            textColor: 'text-black',
            content: 'Whether you are a sell-side firm, a buy-side firm, or a wealth management firm, you can interact with markets consuming market data, and trading using a host of protocols such as CLOB, Quotes, RFQs, Auctions, Lists and Portfolios across all Fixed Income ECNs. FGC TMS will customize the trading to your needs.'
        },
        {
            id: '02',
            title: 'Centralized Operations',
            color: 'bg-[#00C2FF]',
            textColor: 'text-white',
            content: 'One place to monitor trades, positions, breaks, P&Ls, payouts, and regulatory status—no spreadsheets, no guesswork, Three way reconciled, what you traded, what you cleared, and what you reported.'
        },
        {
            id: '03',
            title: 'Embedded Compliance & Risk',
            color: 'bg-[#070E21]',
            textColor: 'text-white',
            content: 'Real-time monitoring, alerts, and audit trails of risk and compliance controls built directly into daily workflows.'
        },
        {
            id: '04',
            title: 'Managed SaaS Delivery',
            color: 'bg-[#DCDCDC]',
            textColor: 'text-black',
            content: 'Fully managed cloud service with monitoring, upgrades, and support handled by Fintech Global Center, an ISO27001 and a SOC2 Type II certified company.'
        }
    ];

    return (
        <section className="w-full bg-white py-20 pb-32">
            <div className="max-w-[1270px] mx-auto px-4 sm:px-6 lg:px-8">
                {/* Header */}
                <div className="text-center mb-16 px-4">
                    <h2 className="font-oswald text-black text-4xl md:text-6xl font-bold mb-4 uppercase tracking-tight text-center">
                        PRODUCT CAPABILITIES
                    </h2>
                    <p className="font-inter text-gray-600 text-lg md:text-xl text-center">
                        Four core pillars that power your fixed-income operations
                    </p>
                </div>

                {/* Cards - Static Vertical Stack */}
                <div className="flex flex-col gap-6">
                    {cards.map((card) => (
                        <div
                            key={card.id}
                            className={`
                                w-full rounded-[16px] p-8 md:p-10
                                ${card.color} ${card.textColor}
                            `}
                            style={{
                                minHeight: '201px'
                            }}
                        >
                            <div className="flex flex-col h-full justify-center gap-4">
                                <h3 className="font-inter text-2xl md:text-3xl font-bold">
                                    <span className="font-inter font-semibold">({card.id})</span> {card.title}
                                </h3>
                                <p className="font-inter text-sm md:text-base leading-relaxed opacity-90 max-w-4xl">
                                    {card.content}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="text-center mt-12">
                    <Link
                        to="/Features"
                        className="bg-[#00C2FF] hover:scale-105 transition-transform duration-300 text-[#FFFFFF] text-[14px] sm:text-[16px] md:text-lg font-bold py-3.5 sm:py-3 md:py-4 px-7 sm:px-8 md:px-12 rounded-[16px] shadow-lg whitespace-nowrap md:-mt-12 inline-block text-center"
                    >
                        View More Features
                    </Link>
                </div>
            </div>
        </section>
    );
};

export default ProductCapabilities;
